export function findIncluded(included, ref) {
  if (!ref || !included || !included.length) return null

  return included.find(
    (item) => String(item.id) === String(ref.id) && item.type === ref.type
  )
}

export function directQuoteRequest(job, included) {
  if (!job || !job.relationships || !job.relationships.directQuoteRequest) return null

  const directQuoteRequestRef = job.relationships.directQuoteRequest.data
  if (!directQuoteRequestRef) return null

  return findIncluded(included, directQuoteRequestRef)
}

export function directQuoteRequestBusiness(job, included) {
  const dqr = directQuoteRequest(job, included)
  if (!dqr || !dqr.relationships || !dqr.relationships.business) return null

  return findIncluded(included, dqr.relationships.business.data)
}

export function undistributedDirectQuoteRequest(job, included) {
  const dqr = directQuoteRequest(job, included)
  if (!dqr || dqr.attributes.distributedAt) return null

  return dqr
}
